import type UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import { post } from '@alltrails/core/utils/post';
import type PaymentMethodType from '../types/PaymentMethodType';
import type ProResponse from '../types/ProResponse';
import type TokenizationSource from '../types/TokenizationSource';

type SubscriptionBase = {
  app_source?: string;
  apple_pay_token?: string;
  appsflyer_id?: string;
  cc_token?: string;
  coupon_code?: string;
  google_pay_token?: string;
  os_version?: string;
  paypal_token?: string;
  price_code: string;
  recaptcha: string;
  rei?: boolean;
  uid: number;
  upsell_trigger?: UpsellTrigger;
};

type Subscription =
  | (SubscriptionBase & {
      payment_method_type?: never;
      token?: never;
      tokenization_source?: never;
    })
  | (SubscriptionBase & {
      payment_method_type: PaymentMethodType;
      token: string;
      tokenization_source: TokenizationSource;
    });

// https://alpha.mostpaths.com/api/docs#tag/Need-Automation/operation/CreateSubscriptionUpgrade
export default async function createSubscriptionUpgrade(subscription: Subscription) {
  return post<ProResponse>('/api/alltrails/purchases/subscription_upgrades', subscription);
}
